import React, { useState, useEffect } from 'react';
import UpgradeModal from './UpgradeModal';
import { useAuth } from '../context/AuthContext';

export const UpgradeModalManager = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [feature, setFeature] = useState('default');
  const { user } = useAuth();

  useEffect(() => {
    const handleUpgradeRequired = (event) => {
      setFeature(event.detail?.feature || 'default');
      setIsOpen(true);
    };

    window.addEventListener('upgrade-required', handleUpgradeRequired);

    return () => {
      window.removeEventListener('upgrade-required', handleUpgradeRequired);
    };
  }, []);

  return (
    <UpgradeModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      feature={feature}
      currentTier={user?.subscription?.tier}
    />
  );
};

export default UpgradeModalManager;
